import styled from "styled-components"

const CDiv = styled.div`
    background: #fff;
    padding: 32px;
    border-radius: 24px;
`;

export default function ContentCard (props) {
    return (
        <CDiv {...props}>
            {props.children}
        </CDiv>
    )
}